import { Property } from '@square/ignition';

interface Options {
  isEnum?: boolean;
  isEntity?: boolean;
  isArray?: boolean;
  isMap?: boolean;
  type?: Property['type'] | undefined;
}

const getDefaultForPropertyValues = ({
  isEnum,
  isEntity,
  isArray,
  isMap,
  type,
}: Options): unknown => {
  if (isEnum) {
    return '';
  } else if (isEntity) {
    return {};
  } else if (isArray) {
    return [];
  } else if (isMap) {
    return {};
  } else {
    // primitives
    if (type === 'integer') {
      return 0;
    } else if (type === 'boolean') {
      return false;
    } else {
      return '';
    }
  }
};

const getDefaultValueForProperty = (property: Property): unknown => {
  return getDefaultForPropertyValues({
    isEnum: property.isEnum,
    isEntity: property.isEntity,
    isArray: property.isArray,
    isMap: property.isMap,
    type: property.type,
  });
};

const getDefaultForItemInProperty = (property: Property): unknown => {
  if (property.containsEnum) {
    return getDefaultForPropertyValues({
      isEnum: true,
    });
  } else if (property.itemEntity) {
    return getDefaultForPropertyValues({ isEntity: true });
  } else {
    return getDefaultForPropertyValues({
      type: property.itemType,
    });
  }
};

export { getDefaultValueForProperty, getDefaultForItemInProperty };
